var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "email-receipt" } }, [
    _c("div", { staticClass: "field" }, [
      _c("div", { attrs: { id: "email-label" } }, [_vm._v("Email Address")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.$v.email.$model,
            expression: "$v.email.$model",
            modifiers: { trim: true },
          },
          { name: "focus", rawName: "v-focus" },
        ],
        ref: "email",
        staticClass: "input-secondary",
        class: _vm.emailFieldClass,
        attrs: { id: "email", type: "email" },
        domProps: { value: _vm.$v.email.$model },
        on: {
          blur: [
            _vm.$v.email.$touch,
            function ($event) {
              return _vm.$forceUpdate()
            },
          ],
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.$v.email, "$model", $event.target.value.trim())
          },
        },
      }),
      _vm.$v.email.$dirty && !_vm.$v.email.required && _vm.readyToSend
        ? _c("div", { staticClass: "error-message" }, [
            _vm._v("Email is required."),
          ])
        : _vm._e(),
      _vm.$v.email.$dirty && !_vm.$v.email.email && _vm.readyToSend
        ? _c("div", { staticClass: "error-message" }, [
            _vm._v("Invalid email address."),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "field", attrs: { id: "button-wrapper" } }, [
      _c(
        "button",
        {
          class: _vm.sendButtonClass,
          attrs: { id: "send" },
          on: { click: _vm.sendEmailReceipt },
        },
        [_vm._v("Send")]
      ),
      _c(
        "button",
        {
          staticClass: "button-secondary",
          attrs: { id: "cancel" },
          on: { click: _vm.cancel },
        },
        [_vm._v("Cancel")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }